<pgh-modal-window>
  <div modal-close>
    <button mat-icon-button class="close-button mat-icon-button" sf-aria-label="Global_Close_Window" matDialogClose>
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div modal-title>
    <h4 style="font-weight:400 !important;font-size:18px !important;">{{deviceTypeDisplayName}}</h4>
  </div>
  <div modal-title>
    <h2>{{title}}</h2>
  </div>
  <div modal-body class="mt-30 mb-30">
    <form [formGroup]="deviceDetailsForm" name="EditDeviceDetailsFormGroup">
      <div class="row">
        <adp-input matInput class="w-100 nickname-ip" formControlName="nickName" [resourceData]="getResource('Nickname')"></adp-input>
      </div>
    </form>
  </div>
  <div modal-footer>
    <div class="row reverse-wrap">
      <div class="col-md-6">
        <button mat-stroked-button color="primary" class="border-0" (click)="onCancelClicked()">
          <adp-label [labelKey]="cancelButtonLabelKey"></adp-label>
        </button>
      </div>
      <div class="col-md-6">
        <button mat-flat-button color="accent" (click)="onSaveClicked()" [disabled]="deviceDetailsForm.invalid || isSaving">
          <adp-label [labelKey]="submitButtonLabelKey"></adp-label>
        </button>
      </div>
    </div>
  </div>
</pgh-modal-window>
